module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.46cd0165.png";